import React from 'react';
import Sidebar from '../../components/common/Sidebar';
import Navbar from '../../components/common/Navbar';
import HRAdminPanel from '../components/dashboards/HRAdminPanel';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';
import '../css/wrms.css';

const HRAdminPanelPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!['hr', 'admin'].includes(user?.role)) {
    return (
      <div className="d-flex wrms-page">
        <Sidebar />
        <div className="flex-grow-1">
          <Navbar />
          <div className="wrms-container">
            <div className="wrms-empty-state">
              <div className="wrms-empty-state-icon"><FaLock size={36} color="#94a3b8" /></div>
              <h5>Access Denied</h5>
              <p>Only HR and Admin users can access this panel.</p>
              <button className="wrms-btn-primary" onClick={() => navigate('/wrms')} style={{ marginTop: '16px' }}>
                Back to Request Portal
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex wrms-page" style={{ width: '100%', maxWidth: '100vw', overflowX: 'hidden' }}>
      <Sidebar />
      <div className="flex-grow-1 wrms-main-content" style={{ minWidth: 0, maxWidth: '100vw' }}>
        <Navbar />
        <div className="wrms-container">
          <div className="wrms-page-header">
            <div className="wrms-header-info">
              <div className="wrms-breadcrumb">Requests · <span>HR / Admin Panel</span></div>
              <h1 className="wrms-page-title">HR / Admin Control Panel</h1>
              <p className="wrms-page-subtitle">Full visibility, manual override, leave balance management, and export for all requests.</p>
            </div>
          </div>
          <HRAdminPanel />
        </div>
      </div>
    </div>
  );
};

export default HRAdminPanelPage;
